<template>
  <div>
    <div class="common-seach-wrap">
      <el-form size="mini" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <el-input size="mini" v-model="searchForm.phone" placeholder="请输入手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" icon="el-icon-search" @click="searchSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%"
                  class="myOrder"
                  height="calc(100vh - 330px)"
                  v-loading="loading">
          <el-table-column prop="id" label="Id" width="50"></el-table-column>
          <el-table-column prop="packetNo" label="卡券编号"></el-table-column>
          <el-table-column prop="nickname" label="会员昵称"></el-table-column>
          <el-table-column prop="phone" label="手机号码"></el-table-column>
          <el-table-column prop="packetPrice" label="卡券金额"></el-table-column>
          <el-table-column prop="endTime" label="到期时间" width="165"></el-table-column>
          <el-table-column prop="limitationPrice" label="使用金额下限"></el-table-column>
          <el-table-column prop="isUsed" label="使用状态">
            <template slot-scope="scope">
              <span>{{ scope.row.isUsed === 0 ? '未使用' : '已使用' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="领取时间" width="165"></el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ActivityApi from '@/api/activity.js'

export default {
  name: 'packetRecordComponent',
  props: ['activityId'],
  data () {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      searchForm: {
        phone: ''
      },
      /*当前是第几页*/
      curPage: 1,
      dialogVisible: false,
      editForm: {
        phone: ''
      }
    }
  },
  watch: {
    activityId: {
      handler (newValue) {
        this.getData()
      },
      immediate: true
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.curPage = val
      self.getData()
    },

    searchSubmit () {
      let self = this
      self.curPage = 1
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getData()
    },
    getData () {
      let self = this
      let Params = {}
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.activityId = self.activityId
      if (this.searchForm.phone) {
        Params.phone = this.searchForm.phone
      }
      self.loading = true
      ActivityApi.getPacketRecordList(Params, true).then(res => {
        self.tableData = res.data.records
        self.totalDataNumber = res.data.total
        self.loading = false
      }).catch(error => {
        self.loading = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/coupon/activity/component/packetRecordComponent.vue